module.exports = __webpack_public_path__ + "videos/3d-painting_en.890b476.mp4";